export default __webpack_public_path__ + "static/media/trash_bucket.f6c8a46b.svg";